// extracted by mini-css-extract-plugin
export default {"root":"activity_type_badge-module___root___f3d4becf","icon":"activity_type_badge-module___icon___d31c36bd","text":"activity_type_badge-module___text___a65d0317"};